import { Injectable, inject } from '@angular/core';
import { getAuth } from 'firebase/auth';
import { AuthBridge } from '@crewdle/auth-bridge';
import { WhiteLabelService } from '@crewdle/white-label/angular';

import { getFirebaseApp } from '../firebase';
import { environment } from '../../../environments/environment';

/**
 * Holds the shared-session bridge to the centralized auth service
 * (auth.crewdle.ai). Used by the auth guard to silently bootstrap a local
 * Firebase session from the `.crewdle.ai` cookie, or redirect to login.
 *
 * On a partner custom domain the bridge targets the partner's own auth origin
 * (an isolated SSO realm), resolved by the white-label service from this
 * hostname's `domains/{hostname}` doc; crewdle.ai domains keep the
 * environment default.
 */
@Injectable({ providedIn: 'root' })
export class AuthBridgeService {
  private readonly whiteLabel = inject(WhiteLabelService);

  readonly bridge = new AuthBridge({
    auth: getAuth(getFirebaseApp()),
    authBaseUrl: () => this.whiteLabel.authBaseUrl(environment.authBaseUrl),
  });
}
